import { getIconProps, type IconProps } from '#types'

/**
 * Graduation icon — mortarboard cap with tassel cord.
 *
 * Used for lessons / instruction / education surfaces.
 *
 * Figma exports this glyph cropped to its stroke bounds (21.5 × 19.5); the
 * translate centers that artwork in the library's 24 × 24 box so it optically
 * matches the other nav icons.
 *
 * @example
 * ```tsx
 * <GraduationIcon className="size-5" />
 * ```
 */
export function GraduationIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <g transform="translate(1.25 2.25)">
        <path
          d="M8.53272 1.24965C9.95372 0.58345 11.5462 0.58345 12.9672 1.24965L19.6584 4.38664C21.1139 5.06899 21.1139 7.43105 19.6584 8.11341L12.9673 11.2504C11.5463 11.9165 9.95381 11.9165 8.53281 11.2504L1.8416 8.11336C0.38613 7.43101 0.386135 5.06895 1.8416 4.38659L8.53272 1.24965Z"
          stroke="currentColor"
          strokeWidth={strokeWidth}
        />
        <path
          d="M20.75 6.25V11.75"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d="M17.75 9.25V14.3754C17.75 15.3834 17.2465 16.3272 16.3647 16.8156C14.8963 17.6287 12.546 18.75 10.75 18.75C8.95399 18.75 6.6037 17.6287 5.13533 16.8156C4.2535 16.3272 3.75 15.3834 3.75 14.3754V9.25"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
